import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const FlexWrap = styled(Flex)`
  gap: 30px;
`

export const SpinWrapper = styled(Flex)`
  padding-top: 50%;
`

export const AlertTag = styled(Flex)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  gap: 15px;
  background: #fef6f1;
  border-radius: 10px;
  margin-bottom: 20px;
`

export const AlertText = styled(Flex)`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #1b1f22;
`
export const RightFlex = styled(Flex)`
  gap: 10px;
  width: 100vh;
`
export const LeftFlex = styled(Flex)`
  gap: 20px;
`
export const DetailsTitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  margin-bottom: 20px;
  color: ${COLORS.GREY_T_20};
`
export const DetailsNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_50_2};
  flex: 0.3;
`
export const ContentDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  flex: 0.8;
  text-overflow: ellipsis;
  text-transform: ${props => !props?.noCap && 'capitalize'};
`

export const Space = styled.div`
  margin-bottom: 25px;
`

export const ActiveHeaderTop = styled.div`
  display: flex;
  justify-content: end;

  padding: 8px;
  margin-left: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #343e59;
  text-transform: capitalize;
`
